import { PencilIcon } from '@heroicons/react/24/outline';
import React from 'react';

import { DiscriminatedMatterUpdatedEvent } from '@/services/api/generated/matterChangesService';

import {
  ActivityBody,
  ActivityDiffList,
  ActivityIcon,
  ActivityItem,
  ActivityTitle,
} from '../activity-feed-v2';
import { getUserFromEvent } from '../activity-feed-v2/ActivityDiffList';

export interface MatterUpdatedEventProps {
  event: DiscriminatedMatterUpdatedEvent;
}

export const MatterUpdatedEvent: React.FC<MatterUpdatedEventProps> = ({
  event,
}) => {
  const { matter, diff } = event.payload;
  const user = getUserFromEvent(event);

  const icon = (
    <ActivityIcon
      icon={
        <div className="flex h-6 w-6 items-center justify-center rounded-full bg-purple-100">
          <PencilIcon className="h-4 w-4 text-purple-600" />
        </div>
      }
    />
  );

  const body = (
    <ActivityBody>
      {matter?.name && <ActivityTitle>{matter.name}</ActivityTitle>}
      {diff && <ActivityDiffList diff={diff} defaultExpanded={false} />}
    </ActivityBody>
  );

  return (
    <ActivityItem
      icon={icon}
      title="Matter Updated"
      timestamp={new Date(event.occurred_at ?? new Date())}
      user={user}
      body={body}
    />
  );
};
